import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import "./StudentLogin.css";

export default function StudentLogin() {
  const { loginStudent } = useAuth();
  const [studentId, setStudentId] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = () => {
    const students = JSON.parse(localStorage.getItem("students")) || [];

    // Find matching student by ID + password
    const found = students.find(
      (s) => s.id === studentId && s.password === password
    );

    if (found) {
      loginStudent(found); // save student object into AuthContext
      localStorage.setItem("studentUser", JSON.stringify(found)); // persist session
      window.location.href = "/student-dashboard"; // redirect
    } else {
      alert("❌ Invalid Student ID or Password");
    }
  };

  return (
    <div className="login-container">
      <h2>🎓 Student Login</h2>

      <input
        type="text"
        placeholder="Student ID"
        value={studentId}
        onChange={(e) => setStudentId(e.target.value)}
      />

      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <button onClick={handleLogin}>Login</button>
    </div>
  );
}
